// Lightweight i18n for the SvgTrace SVG-to-PNG converter.
//
// Usage in components:
//   import { t } from "./i18n";
//   <button>{t("Convert and Download PNG")}</button>
//
// English text is the key; lookups fall back to English when a translation
// is missing. Locale is detected once at module load from (in order):
//   1. ?lang=xx query string (set by the parent svgtrace.com landing page)
//   2. document.documentElement.lang
//   3. navigator.language
// Translations are generated by claude-translate (see /translation/config.json).

import en from "./strings/en.json";
import es from "./strings/es.json";
import fr from "./strings/fr.json";
import de from "./strings/de.json";
import ptBR from "./strings/pt-BR.json";
import ja from "./strings/ja.json";
import zhCN from "./strings/zh-CN.json";
import it from "./strings/it.json";

import enUS_antd from "antd/locale/en_US";
import es_antd from "antd/locale/es_ES";
import fr_antd from "antd/locale/fr_FR";
import de_antd from "antd/locale/de_DE";
import ptBR_antd from "antd/locale/pt_BR";
import ja_antd from "antd/locale/ja_JP";
import zhCN_antd from "antd/locale/zh_CN";
import it_antd from "antd/locale/it_IT";

const STRINGS = {
  en,
  es,
  fr,
  de,
  "pt-BR": ptBR,
  ja,
  "zh-CN": zhCN,
  it,
};

const ANTD_LOCALES = {
  en: enUS_antd,
  es: es_antd,
  fr: fr_antd,
  de: de_antd,
  "pt-BR": ptBR_antd,
  ja: ja_antd,
  "zh-CN": zhCN_antd,
  it: it_antd,
};

function isLangCode(value) {
  return !!value && Object.prototype.hasOwnProperty.call(STRINGS, value);
}

function detectLocale() {
  if (typeof window === "undefined") return "en";

  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get("lang");
  if (isLangCode(fromQuery)) return fromQuery;

  const fromHtml = document.documentElement.lang;
  if (isLangCode(fromHtml)) return fromHtml;

  const nav = (navigator.language || "").replace("_", "-");
  if (isLangCode(nav)) return nav;
  const short = nav.split("-")[0];
  for (const code of Object.keys(STRINGS)) {
    if (code.split("-")[0] === short) return code;
  }
  return "en";
}

export const locale = detectLocale();

if (typeof document !== "undefined") {
  document.documentElement.lang = locale;
}

const dict = STRINGS[locale] || STRINGS.en;

export function t(key) {
  const hit = dict[key];
  return typeof hit === "string" && hit.length > 0 ? hit : key;
}

export const antdLocale = ANTD_LOCALES[locale];
